import { useEffect, useState } from "react";

/**
 * First-open latch for a lazily-loaded overlay. Returns `true`
 * once `open` has been `true` at least once, and stays `true`
 * thereafter. Mounting an overlay on this latch (rather than on the
 * `open` flag directly) keeps the original always-mounted behavior
 * AFTER first open — the overlay self-gates to `null` when closed,
 * so any persistent internal state (a typed chat draft, a cached
 * leaderboard fetch) survives a close→reopen exactly
 * as it did before the split. The only change from the prior
 * always-mounted form is that the chunk is not pulled until the
 * overlay is opened for the first time.
 */
export function useFirstOpenLatch(open: boolean): boolean {
  const [opened, setOpened] = useState(open);
  useEffect(() => {
    if (open) setOpened(true);
  }, [open]);
  return opened;
}
